import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";

import bg1 from "../../../assets/images/blog/single04.jpg";
import client from "../../../assets/images/client/04.jpg";

import NavbarTwo from "../../../components/navbar/navbarTwo";
import BlogSidebarTwo from "../../../components/blog/blogSidebarTwo";
import Comments from "../../../components/blog/comments";
import FooterThree from "../../../components/footer/footerThree";
import ScrollTop from "../../../components/scrollTop";

import { FiArrowRight, FiHome, FiArrowLeft } from "../../../assets/icons/vander";

// Import Firebase dependencies
import { getFirestore, doc, getDoc } from "firebase/firestore";

import app from "../../../firebase/firebase";

const db = getFirestore(app);

export default function BlogDetailThree() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch the blog post from Firestore's "recipes-blog" collection.
  useEffect(() => {
    async function fetchData() {
      try {
        const docRef = doc(db, "recipes-blog", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setData(docSnap.data());
        } else {
          console.error("No such document!");
        }
      } catch (error) {
        console.error("Error fetching blog post:", error);
      } finally {
        setLoading(false);
      }
    }
    if (id) {
      fetchData();
    }
  }, [id]);

  // Render Skeleton UI while loading
  if (loading) {
    return (
      <>
        <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light" />
        <section className="bg-half-170 d-table w-100">
          <Skeleton variant="rectangular" width="100%" height={400} />
        </section>
        <section className="section bg-light">
          <div className="container">
            <Skeleton variant="text" width="60%" height={40} />
            <Skeleton variant="text" width="40%" height={30} />
            <Skeleton variant="rectangular" width="100%" height={200} />
          </div>
        </section>
        <FooterThree />
        <ScrollTop />
      </>
    );
  }

  if (!data) {
    return <div>Blog post not found.</div>;
  }

  // Format the timestamp to "29th Nov 2023"
  let formattedDate = "Unknown date";
  if (data.timestamp && data.timestamp.toDate) {
    const dateObj = data.timestamp.toDate();
    const day = dateObj.getDate();
    const suffix =
      day % 100 >= 11 && day % 100 <= 13
        ? "th"
        : day % 10 === 1
        ? "st"
        : day % 10 === 2
        ? "nd"
        : day % 10 === 3
        ? "rd"
        : "th";
    const month = dateObj.toLocaleString("en-US", { month: "short" });
    const year = dateObj.getFullYear();
    formattedDate = `${day}${suffix} ${month} ${year}`;
  }

  return (
    <>
      <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light" />
      <section
        className="bg-half-170 d-table w-100"
        style={{ backgroundImage: `url(${data["header-image-url"] || bg1})` }}
      >
        <div className="bg-overlay bg-gradient-overlay"></div>
        <div className="container">
          <div className="row g-0 align-items-center mt-5">
            <div className="col-12">
              <div className="title-heading">
                <h5 className="heading fw-semibold page-heading text-white title-dark">
                  {data.title || "Default Blog Title"}
                </h5>
                <ul className="list-inline text-start mb-0 mt-4">
                  <li className="list-inline-item me-md-5 me-4 me-sm-0 mt-4">
                    <span className="text-white-50 d-block">Author</span>
                    <Link to="/blog-author" className="text-white title-dark">
                      {data.author || "Christina Gonzalez"}
                    </Link>
                  </li>
                  <li className="list-inline-item me-md-5 me-4 me-sm-0 mt-4">
                    <span className="text-white-50 d-block">Date</span>
                    <span className="text-white title-dark">{formattedDate}</span>
                  </li>
                  <li className="list-inline-item me-md-5 me-4 me-sm-0 mt-4">
                    <span className="text-white-50 d-block">Read Time</span>
                    <span className="text-white title-dark">
                      {data["read-time"] ? `${data["read-time"]} min read` : "8 min read"}
                    </span>
                  </li>
                </ul>
              </div>
              <div className="position-absolute top-50 end-0 d-none d-md-block">
                <nav aria-label="breadcrumb" className="d-flex rotateLarge">
                  <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                    <li className="breadcrumb-item"><Link to="/">Blog</Link></li>
                    <li className="breadcrumb-item"><Link to="/recipes-blog-home">Insurance</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {data.title
                        ? data.title.length > 15
                          ? data.title.slice(0, 15) + "..."
                          : data.title
                        : "Insurance"}
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section bg-light">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-6">
              <div className="card">
                <div className="card-body shadow rounded">
                  {/* Render the blog post content */}
                  <div
                    className="text-muted"
                    dangerouslySetInnerHTML={{ __html: data.content || "" }}
                  ></div>
                  {/* Render tags below the content */}
                  {data.tags && data.tags.length > 0 && (
                  <div className="mt-3">
                      {data.tags.map((tag, index) => (
                      <div key={index} className="badge text-bg-primary me-1">
                          {tag}
                      </div>
                      ))}
                  </div>
                  )}
                  {data["bottom-image-url"] && (
                    <div className="card mt-4 rounded overflow-hidden">
                      <img
                        src={data["bottom-image-url"]}
                        className="img-fluid rounded shadow"
                        alt=""
                      />
                      <div className="position-absolute bottom-0 start-50 translate-middle-x text-center mb-3 ms-4">
                        <p className="fst-italic text-white mb-0">{data.description}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="card shadow rounded border-0 mt-4">
                <Comments />
              </div>
              <div className="card shadow rounded border-0 mt-4">
                <div className="card-body">
                  <h5 className="card-title mb-0">Leave A Comment :</h5>
                  <form className="mt-4">
                    <div className="row pt-3">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">Your Comment</label>
                          <textarea id="message" placeholder="Your Comment" rows="5" name="message" className="form-control" required=""></textarea>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <label className="form-label">Name <span className="text-danger">*</span></label>
                          <input id="name" name="name" type="text" placeholder="Name" className="form-control" required=""/>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <label className="form-label">Your Email <span className="text-danger">*</span></label>
                          <input id="email" type="email" placeholder="Email" name="email" className="form-control" required=""/>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="send d-grid">
                          <button type="submit" className="btn btn-primary">Send Message</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="card shadow rounded border-0 mt-4">
                <div className="card-body">
                  <h5 className="card-title mb-0">Related News :</h5>
                  <div className="row mt-2">
                    <div className="col-lg-6 mt-4 pt-2">
                      <div className="card blog blog-primary shadow rounded overflow-hidden">
                        <div className="image position-relative overflow-hidden">
                          <img src={data["header-image-url"] || bg1} className="img-fluid" alt="" />
                          <div className="blog-tag">
                            <Link to="#" className="badge text-bg-light">Branding</Link>
                          </div>
                        </div>
                        <div className="card-body content">
                          <Link to="/blog-detail-three" className="h5 title text-dark d-block mb-0">Related Post Title</Link>
                          <p className="text-muted mt-2 mb-2">Short description of related post.</p>
                          <Link to="/blog-detail-three" className="link text-dark">
                            Read More <FiArrowRight className="align-middle" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 mt-4 pt-2">
                      <div className="card blog blog-primary shadow rounded overflow-hidden">
                        <div className="image position-relative overflow-hidden">
                          <img src={data["header-image-url"] || bg1} className="img-fluid" alt="" />
                          <div className="blog-tag">
                            <Link to="#" className="badge text-bg-light">Technology</Link>
                          </div>
                        </div>
                        <div className="card-body content">
                          <Link to="/blog-detail-three" className="h5 title text-dark d-block mb-0">Related Post Title</Link>
                          <p className="text-muted mt-2 mb-2">Short description of related post.</p>
                          <Link to="/blog-detail-three" className="link text-dark">
                            Read More <FiArrowRight className="align-middle ms-1" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mt-5">
                      <div className="d-flex align-items-center justify-content-between">
                        <Link to="/blog-detail-three" className="text-dark align-items-center">
                          <span className="pro-icons">
                            <FiArrowLeft className="fea icon-sm align-middle" />
                          </span>
                          <span className="text-muted d-none d-lg-inline-block">Previous Post</span>
                        </Link>
                        <Link to="/" className="btn btn-lg btn-pills btn-icon btn-soft-primary">
                          <FiHome className="icons" />
                        </Link>
                        <Link to="/blog-detail-three" className="text-dark align-items-center">
                          <span className="pro-icons">
                            <FiArrowRight className="align-middle ms-1" />
                          </span>
                          <span className="text-muted d-none d-lg-inline-block">Next Post</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <BlogSidebarTwo client={client} name={data.author || "Christina Gonzalez"} />
          </div>
        </div>
      </section>
      <FooterThree />
      <ScrollTop />
    </>
  );
}
